<template>
  <v-select
    v-model="selected"
    @change="setNoteTags"
    :items="noteTagOptions"
    item-text="name"
    return-object
    item-key="tagId"
    label="Select Tags"
    multiple
    chips
    deletable-chips
    @click:clear="setNoteTags"
    clearable
    dense
    outlined
    class="mt-2 ml-3"
  >
    <template v-slot:selection="data">
      <v-chip
        v-bind="data.attrs"
        :input-value="data.selected"
        close
        @click="data.select"
        @click:close="remove(data.item)"
        small
        label
        color="primary"
      >
        <v-icon x-small left> mdi-label </v-icon>
        {{ data.item.name }}
      </v-chip>
    </template>
    <template v-slot:item="{ item }">
      <v-chip x-small label color="primary">
        <v-icon x-small left> mdi-label </v-icon>{{ item.name }}</v-chip
      >
    </template>
  </v-select>
</template>
<script>
export default {
  props: ["noteTags"],
  data() {
    return {
      selected: this.noteTags && [...this.noteTags],
    };
  },
  computed: {
    noteTagOptions() {
      return this.$store.state.optionsModule.caseNoteTags;
    },
  },
  methods: {
    setNoteTags() {
      this.$emit("setNoteTags", this.selected);
    },
    remove(item) {
      this.selected.splice(this.selected.indexOf(item), 1);
      this.setNoteTags();
    },
  },
};
</script>
